import { useMutation } from '@tanstack/react-query';

import type { AuthCustomer } from '@getjust/api-schema';

import { authAPI } from '$src/http';

export const MUTATION_VERIFY_PHONE_CHALLENGE_KEY = 'MUTATION/VERIFY_PHONE_CHALLENGE';

export interface VerifyPhoneChallengeParams {
  phoneNumber: string;
  code: string;
}

export interface VerifyPhoneChallengeResult {
  outcome: 'verified' | 'failed';
  error?: string;
}

export const useVerifyPhoneChallenge = () => {
  return useMutation({
    mutationFn: async (params: VerifyPhoneChallengeParams): Promise<VerifyPhoneChallengeResult> => {
      const payload: AuthCustomer.VerifyPhoneChallengeRequestBody = {
        phoneNumber: params.phoneNumber,
        code: params.code,
      };

      const { data } = await authAPI.post<AuthCustomer.VerifyPhoneChallengeResponseBody>(
        '/verify-phone-challenge',
        payload,
      );

      return data;
    },
    mutationKey: [MUTATION_VERIFY_PHONE_CHALLENGE_KEY],
  });
};

